let getNoDataTpl;
getNoDataTpl = function (query, isMain) {
  return `<div class="search-article__nodata">
            <div class="nodata">
              <strong>검색 결과가 없습니다.</strong>
              <ol>
                <li>검색어의 철자가 정확한지 확인해주세요.</li>
                <li>검색어가 두 단어 이상일 경우, 띄어쓰기를 확인해주세요.</li>
                ${isMain ? '' : '<li><a href="/search/index?query=' + JSON.stringify(query) + '">[전체]</a> 탭에서 다시 검색해 보세요.</li>'}
              </ol>
            </div>
          </div>`;
};

export {
  getNoDataTpl
};


// WEBPACK FOOTER //
// ./_src/js/search/common/tpl.js